
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Services from '../pages/services/page';
import WhyChooseUs from '../pages/why-choose-us/page';
import CoreValues from '../pages/core-values/page';
import MarketSegment from '../pages/market-segment/page';
import Quote from '../pages/quote/page';
import Sustainability from '../pages/sustainability/page';
import Team from '../pages/team/page';
import FAQ from '../pages/faq/page';
import Blog from '../pages/blog/page';
import Contact from '../pages/contact/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/services',
    element: <Services />
  },
  {
    path: '/why-choose-us',
    element: <WhyChooseUs />
  },
  {
    path: '/core-values',
    element: <CoreValues />
  },
  {
    path: '/market-segment',
    element: <MarketSegment />
  },
  {
    path: '/quote',
    element: <Quote />
  },
  {
    path: '/sustainability',
    element: <Sustainability />
  },
  {
    path: '/team',
    element: <Team />
  },
  {
    path: '/faq',
    element: <FAQ />
  },
  {
    path: '/blog',
    element: <Blog />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
